import { dateStrToDate } from './datetimes';
export const roundPoints = (points) => {
    if (!points || isNaN(Number(points)))
        return 0;
    return parseInt(parseFloat(points.toString()).toFixed(0));
};
export const getIsPointShowRewardExpired = (item) => {
    const { end_date } = item;
    return end_date ? dateStrToDate(end_date) < new Date() : false;
};
export const getIsLoyaltyRewardExpired = (item) => {
    const { expires_at } = item;
    return expires_at ? dateStrToDate(expires_at) < new Date() : false;
};
